import centerManagementPage from '@/pages/basic-data-management/center-management';
import HotelList from '@/pages/basic-data-management/hotel-list';

// 中心仓管理
export const centerManagement = {
  path: 'basicData/centerManagement',
  component: centerManagementPage
}

// 门店管理
export const hotelList = {
  path: 'basicData/chainList',
  component: HotelList
}


// WEBPACK FOOTER //
// ./src/router/center-management.js